import i18n from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';

/**
 * @todo: add robust setup for multi language
 */
// const fullLocale =
//   (navigator.languages ? navigator.languages[0] : navigator.language) ?? 'en';
// const locale = fullLocale.slice(0, 2);
const lng = 'en';

export const supportedLocales = ['en'] as const;

i18n
  .use(ICU)
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`./locales/${language}/${namespace}.json`)
    )
  )
  .init({
    // resources,
    lng,
    interpolation: {
      escapeValue: false, // react already safes from xss
      skipOnVariables: false,
    },
  });

export default i18n;
export { lng as locale };
